import cloneDeep from "lodash.clonedeep"
import { observer } from "mobx-react-lite"

import { ComplexTabsList } from "@/domains/common/components/complex-tabs-list"
import useResponsive from "@/hooks/use-responsive"

import { LOCK_PAGE_MOBILE_SWITCH_WIDTH } from "../breadcrumbs"
import { MANAGE_LOCK_TABS } from "../constants"

export const LockPageTabs = observer(() => {
  const { isMobile, width } = useResponsive()

  if (width < LOCK_PAGE_MOBILE_SWITCH_WIDTH) return null

  let tabs = cloneDeep(MANAGE_LOCK_TABS)

  if (isMobile) {
    tabs = tabs.map((tab) => ({
      ...tab,
      icon: undefined,
    }))
  }

  return <ComplexTabsList tabs={tabs} className="" />
})
